export const environment = {
  production: false,
  apiUrl: 'https://api-dev.tribar.app/api',
  googleMapsApiKey: '',
  googleClientId: '529178332975-e9g7geblrpur8barmnvcvi5fkafsp7fo.apps.googleusercontent.com',
  appleClientId: 'app.tribar.panel',
  appleRedirectUri: 'https://panel-dev.tribar.app/auth/apple/callback',
};
